import {
  Alert,
  Button,
  Card,
  CardBody,
  Select,
  SelectItem,
} from '@heroui/react';
import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdatePatientMutation } from '@/patient-app-common/api/patientApi';
import { Language } from '@/patient-app-common/types/Patient';

interface LanguageProps {
  languageId: number;
  languages: Language[];
}

export function Languages({ languageId, languages }: LanguageProps) {
  const { t } = useTranslation('settings');

  const [updatePatient, { isLoading, isError }] = useUpdatePatientMutation();

  const [selectedLanguage, setSelectedLanguage] = useState(languageId);

  const handleSubmit = async () => {
    const params = { languageId: selectedLanguage };

    try {
      await updatePatient(params).unwrap();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="space-y-4">
      <Alert
        className="max-w-lg"
        color="danger"
        description={t('common.error.server')}
        hideIconWrapper
        isVisible={isError}
        variant="faded"
      />
      <div className="space-x-4 pb-4 gap-4">
        <Card className="max-w-xs mb-4" shadow="none">
          <CardBody className="p-0.5">
            <Select
              label={t('common.select.language')}
              defaultSelectedKeys={languageId ? [languageId] : []}
              onChange={(e) => setSelectedLanguage(_.toNumber(e.target.value))}
              variant="bordered"
            >
              {languages.map((lang) => (
                <SelectItem key={lang.id}>{lang.displayName}</SelectItem>
              ))}
            </Select>
          </CardBody>
        </Card>
        <Button color="primary" onPress={handleSubmit} isLoading={isLoading}>
          {t('common.action.save')}
        </Button>
      </div>
    </div>
  );
}
